import { GridColumn } from 'src/components/GridWrapper';
import GLCodeDropDownCell from 'src/sections/invoice_details/lineItemsColumns/GlCodeDropDown';
import PriceTextField from 'src/sections/invoice_details/lineItemsColumns/PriceTextField';
import QuantityReceived from 'src/sections/invoice_details/lineItemsColumns/QuantityReceived';
import TextField from 'src/sections/invoice_details/lineItemsColumns/TextField';

export const ResultingLineItemColumns: GridColumn<any>[] = [
  {
    field: 'quantityReceived',
    title: 'Qty',
    width: 150,
    component: QuantityReceived,
    menu: false,
  },
  {
    field: 'productItemNum',
    title: 'Item #',
    width: '150px',
    component: TextField,
    menu: false,
  },
  {
    field: 'description',
    title: 'Description',
    width: '150px',
    component: TextField,
    menu: false,
  },
  {
    field: 'glCd',
    title: 'GL Code',
    width: '150px',
    component: GLCodeDropDownCell,
    menu: false,
  },
  {
    field: 'uom',
    title: 'UOM',
    width: '200px',
    component: TextField,
    menu: false,
  },
  {
    field: 'priceAmt',
    title: 'Price',
    menu: false,
    component: PriceTextField,
    width: 150,
  },
];

export const CombineLineItemColumns = [
  {
    field: 'quantityReceived',
    title: 'Qty',
    width: '150px',
    menu: false,
  },
  {
    field: 'productItemNum',
    title: 'Item #',
    width: '150px',
    menu: false,
  },
  {
    field: 'description',
    title: 'Description',
    width: '150px',
    menu: false,
  },
  {
    field: 'poGlCd',
    title: 'GL Code',
    width: '150px',
    menu: false,
  },
  {
    field: 'uom',
    title: 'UOM',
    width: '200px',
    menu: false,
  },
  {
    field: 'priceAmt',
    title: 'Price',
    menu: false,
  },
];
